import { Empty, List, Spin } from 'antd';
import React from 'react';

type Props<T> = {
  loading?: boolean;
  dataSource?: T[];
  rowKey: keyof T | ((row: T) => string);
  renderItem: (item: T) => React.ReactNode;
  locale?: { emptyText?: React.ReactNode };
};

function resolveKey<T>(row: T, rowKey: Props<T>['rowKey']) {
  if (typeof rowKey === 'function') return rowKey(row);
  return String(row[rowKey]);
}

/** 移动端/卡片视图列表容器 */
function CardListView<T>({
  loading,
  dataSource,
  rowKey,
  renderItem,
  locale,
}: Props<T>) {
  if (loading && !dataSource?.length) {
    return (
      <div style={{ textAlign: 'center', padding: 48 }}>
        <Spin />
      </div>
    );
  }
  if (!dataSource?.length) {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={locale?.emptyText || '暂无数据'}
        style={{ padding: 48 }}
      />
    );
  }
  return (
    <List
      loading={loading}
      dataSource={dataSource}
      split={false}
      style={{ marginTop: 4 }}
      renderItem={(item) => (
        <List.Item key={resolveKey(item, rowKey)} style={{ padding: '6px 0' }}>
          {renderItem(item)}
        </List.Item>
      )}
    />
  );
}

export default CardListView;
